module.exports = __webpack_public_path__ + "img/firm22.ce99e491.png";